import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiinternatinalairportcab() {



    const cardData = {





keyword: "Navi Mumbai International Airport Cab",

headingDescription: "Shreesha Tours & Travels provides reliable Navi Mumbai International Airport Cab Service for airport pickup, airport drop, corporate travel, business meetings, hotel transfers, family trips, one-way taxi booking, round trips, and outstation journeys. We offer a wide range of chauffeur-driven vehicles including Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Mini Bus, and premium cars to match every travel requirement. With professional drivers, flight tracking, on-time service, clean and well-maintained vehicles, transparent pricing, doorstep pickup, and 24/7 customer support, we ensure a comfortable and hassle-free airport travel experience. Whether you are traveling for business, tourism, family functions, or long-distance trips, Shreesha Tours & Travels offers dependable cab booking services from Navi Mumbai International Airport.",

topPlaces: [
  {
    title: "Navi Mumbai International Airport to Pune",
    description: "Pune is one of the most preferred destinations from Navi Mumbai International Airport, attracting corporate travelers, IT professionals, students, and families. Visitors can explore Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Dagdusheth Ganpati Temple, Koregaon Park, Hinjawadi IT Park, and Kharadi business hubs. A comfortable airport cab service ensures a smooth journey for both business and personal travel."
  },
  {
    title: "Navi Mumbai International Airport to Lonavala",
    description: "Lonavala is a popular hill station near Mumbai known for Tiger Point, Bhushi Dam, Karla Caves, Rajmachi Fort, Pawna Lake, and beautiful monsoon landscapes. It is a perfect weekend getaway for families, couples, and corporate groups. Travelers prefer airport cabs for a convenient and comfortable journey directly from Navi Mumbai Airport to this scenic destination."
  },
  {
    title: "Navi Mumbai International Airport to Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station famous for Venna Lake, Arthur's Seat, Mapro Garden, strawberry farms, Elephant's Head Point, and Lingmala Waterfall. The destination offers cool weather, scenic viewpoints, and peaceful surroundings. A spacious cab from Navi Mumbai International Airport provides a relaxing travel experience for families and vacation groups."
  },
  {
    title: "Navi Mumbai International Airport to Shirdi",
    description: "Shirdi is a major pilgrimage destination known for Sai Baba Samadhi Temple, Dwarkamai, Chavadi, Gurusthan, and Lendi Baug. Thousands of devotees travel from across India for Sai Baba darshan. Airport taxi services provide comfortable transportation for families, senior citizens, and groups looking for a safe journey from Navi Mumbai Airport."
  },
  {
    title: "Navi Mumbai International Airport to Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, Sula Vineyards, Ramkund, Pandavleni Caves, and religious as well as tourism attractions. It is a preferred destination for pilgrims, business visitors, and wine tourism enthusiasts. A private cab offers flexible travel timing and a comfortable ride from the airport."
  },
  {
    title: "Navi Mumbai International Airport to Alibaug",
    description: "Alibaug is a beautiful coastal destination near Mumbai known for Kolaba Fort, Alibaug Beach, Varsoli Beach, water sports, resorts, and peaceful sea views. It is an ideal location for weekend holidays and family trips. Cab services from Navi Mumbai Airport make beach travel convenient with doorstep pickup and direct drop facilities."
  },
  {
    title: "Navi Mumbai International Airport to Kolhapur",
    description: "Kolhapur is a historic city known for Mahalaxmi Temple, Panhala Fort, Rankala Lake, Jyotiba Temple, and famous Kolhapuri cuisine. The city attracts pilgrims, tourists, and business travelers throughout the year. A comfortable airport cab is a preferred option for long-distance travel with family and luggage."
  },
  {
    title: "Navi Mumbai International Airport to Ratnagiri",
    description: "Ratnagiri is a scenic Konkan destination famous for Ganpatipule Temple, Ratnadurg Fort, Aare Ware Beach, Thiba Palace, and Alphonso mango orchards. Travelers enjoy coastal drives, beaches, temples, and natural beauty. A private airport taxi provides a comfortable journey through the beautiful Konkan route."
  },
  {
    title: "Navi Mumbai International Airport to Goa",
    description: "Goa is India's most popular holiday destination, offering beautiful beaches, Portuguese churches, forts, nightlife, water sports, and luxury resorts. Many travelers prefer direct airport cab services for a comfortable road trip experience. Vehicles like Innova, Ertiga, and premium cars are ideal for families and groups traveling to Goa."
  },
  {
    title: "Navi Mumbai International Airport to Saputara",
    description: "Saputara is Gujarat's only hill station known for Saputara Lake, Sunset Point, Ropeway, Gira Waterfalls, Artist Village, and lush green landscapes. It is a peaceful destination for nature lovers and family vacations. Cab service from Navi Mumbai International Airport offers convenient and comfortable transportation for travelers visiting this scenic hill destination."
  }
],


"services": [
  {
    "name": "Navi Mumbai International Airport Cab",
    "description": "Book Navi Mumbai International Airport Cab for safe, comfortable, and reliable airport transportation with professional chauffeurs and well-maintained AC vehicles. Enjoy hassle-free pickup and drop services from Navi Mumbai International Airport with options like Sedan, Swift Dzire, Hyundai Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cabs for passengers, families, corporate travelers, and business executives."
  },
  {
    "name": "Navi Mumbai International Airport Taxi",
    "description": "Reserve Navi Mumbai International Airport Taxi for convenient airport transfers with experienced drivers, clean interiors, spacious luggage capacity, and affordable pricing. Our chauffeur-driven taxi service provides smooth travel solutions for airport pickup, airport drop, local destinations, and outstation journeys from Navi Mumbai International Airport."
  },
  {
    "name": "Navi Mumbai International Airport Cab Service",
    "description": "Choose Navi Mumbai International Airport Cab Service for reliable airport transportation available with flexible booking options and 24x7 customer support. Travel comfortably with trained chauffeurs, sanitized AC vehicles, timely arrivals, and premium cab options designed for individuals, families, and corporate passengers."
  },
  {
    "name": "Taxi Service Navi Mumbai International Airport",
    "description": "Book Taxi Service Navi Mumbai International Airport for punctual and affordable airport transfers with professional drivers and comfortable vehicles. Get smooth transportation for airport arrivals, departures, business travel, family trips, and long-distance travel with transparent pricing and dependable service."
  },
  {
    "name": "Book Cab Navi Mumbai International Airport",
    "description": "Book Cab Navi Mumbai International Airport online with instant confirmation, multiple vehicle choices, flexible pickup timings, and reliable chauffeur-driven services. Enjoy easy airport travel planning with clean AC cars, experienced drivers, and convenient transportation solutions."
  },
  {
    "name": "Online Cab Booking Navi Mumbai International Airport",
    "description": "Choose Online Cab Booking Navi Mumbai International Airport for quick, secure, and convenient reservations. Get access to affordable fares, premium vehicles, professional chauffeurs, and 24x7 booking support for airport pickup, drop, and transfer services."
  },
  {
    "name": "Best Cab Navi Mumbai International Airport",
    "description": "Reserve the Best Cab Navi Mumbai International Airport for premium airport travel with experienced chauffeurs, well-maintained vehicles, punctual service, and excellent customer support. Enjoy comfortable rides with Sedan, SUV, Innova, Innova Crysta, and luxury cab options."
  },
  {
    "name": "Cheapest Cab Navi Mumbai International Airport",
    "description": "Book Cheapest Cab Navi Mumbai International Airport with affordable pricing, transparent charges, and reliable transportation services. Get comfortable AC vehicles, professional drivers, and budget-friendly airport transfers without compromising safety and travel quality."
  },
  {
    "name": "Reliable Taxi Navi Mumbai International Airport",
    "description": "Choose Reliable Taxi Navi Mumbai International Airport for safe and convenient airport transfers with verified chauffeurs, clean vehicles, and timely service. Our taxi solutions are suitable for airport passengers, families, corporate travelers, and outstation customers."
  },
  {
    "name": "Cab Service Navi Mumbai International Airport",
    "description": "Reserve Cab Service Navi Mumbai International Airport for comfortable airport transportation with premium vehicles, experienced drivers, and flexible booking options. Enjoy smooth travel for airport pickup, airport drop, corporate transfers, and personal journeys."
  },
  {
    "name": "Navi Mumbai International Airport Pickup Cab",
    "description": "Book Navi Mumbai International Airport Pickup Cab for timely airport arrivals with professional chauffeurs, luggage assistance, and comfortable AC vehicles. Experience convenient pickup service with reliable drivers and direct transfers to your destination."
  },
  {
    "name": "Navi Mumbai International Airport Drop Cab",
    "description": "Choose Navi Mumbai International Airport Drop Cab for punctual departure transfers with clean vehicles, experienced drivers, and affordable fares. Enjoy stress-free airport drop service with flexible pickup locations and comfortable travel."
  },
  {
    "name": "Airport Pickup and Drop Navi Mumbai International Airport",
    "description": "Book Airport Pickup and Drop Navi Mumbai International Airport service for complete airport transportation solutions. Get reliable two-way airport transfers with professional chauffeurs, premium vehicles, timely service, and comfortable travel experience."
  },
  {
    "name": "Innova Cab Navi Mumbai International Airport",
    "description": "Reserve Innova Cab Navi Mumbai International Airport for spacious and comfortable airport travel with extra luggage space, premium seating, and experienced chauffeurs. Perfect for families, groups, corporate passengers, and long-distance airport transfers."
  },
  {
    "name": "Innova Crysta Cab Navi Mumbai International Airport",
    "description": "Choose Innova Crysta Cab Navi Mumbai International Airport for luxury airport transfers with premium interiors, spacious seating, smooth rides, and professional chauffeur service. Ideal for business travelers, families, and passengers looking for extra comfort."
  },
  {
    "name": "Sedan Cab Navi Mumbai International Airport",
    "description": "Book Sedan Cab Navi Mumbai International Airport for affordable and comfortable airport transportation with AC sedan cars, professional drivers, and smooth travel. Suitable for individuals, couples, business trips, and city transfers."
  },
  {
    "name": "SUV Cab Navi Mumbai International Airport",
    "description": "Reserve SUV Cab Navi Mumbai International Airport for spacious airport travel with premium comfort, extra luggage capacity, and reliable chauffeur-driven service. Perfect for families, groups, and passengers requiring more space."
  },
  {
    "name": "Safe Cab Service Navi Mumbai International Airport",
    "description": "Choose Safe Cab Service Navi Mumbai International Airport for secure and comfortable transportation with trained chauffeurs, sanitized vehicles, and reliable service standards. Enjoy a stress-free airport journey with safety-focused travel solutions."
  },
  {
    "name": "AC Taxi Navi Mumbai International Airport",
    "description": "Book AC Taxi Navi Mumbai International Airport for comfortable travel in fully air-conditioned vehicles with professional drivers and affordable fares. Enjoy a relaxing airport transfer experience with clean interiors and smooth rides."
  },
  {
    "name": "Airport Transfer Service Navi Mumbai International Airport",
    "description": "Reserve Airport Transfer Service Navi Mumbai International Airport for reliable pickup and drop solutions with experienced chauffeurs, premium vehicles, and timely transportation. Suitable for business travel, family journeys, and airport connectivity."
  }
],
"tableData": [
  ["Navi Mumbai International Airport Cab", "Navi Mumbai International Airport Taxi"],
  ["Navi Mumbai International Airport Cab Service", "Taxi Service Navi Mumbai International Airport"],
  ["Book Cab Navi Mumbai International Airport", "Online Cab Booking Navi Mumbai International Airport"],
  ["Best Cab Navi Mumbai International Airport", "Cheapest Cab Navi Mumbai International Airport"],
  ["Reliable Taxi Navi Mumbai International Airport", "Cab Service Navi Mumbai International Airport"],
  ["Navi Mumbai International Airport Pickup Cab", "Navi Mumbai International Airport Drop Cab"],
  ["Airport Pickup and Drop Navi Mumbai International Airport", "Innova Cab Navi Mumbai International Airport"],
  ["Innova Crysta Cab Navi Mumbai International Airport", "Sedan Cab Navi Mumbai International Airport"],
  ["SUV Cab Navi Mumbai International Airport", "Safe Cab Service Navi Mumbai International Airport"],
  ["AC Taxi Navi Mumbai International Airport", "Airport Transfer Service Navi Mumbai International Airport"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai International Airport Cab Service",
    WhyChoosedescription: "Shreesha Travels provides dependable Navi Mumbai International Airport cab services for airport pickups, drops, corporate travel, hotel transfers, family trips, and outstation journeys. Enjoy comfortable travel with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup & Drop Assistance",
    WhyChoosedescription: "Our airport taxi service is planned according to your flight schedule, ensuring timely pickups and drops from Navi Mumbai International Airport with smooth coordination and hassle-free travel."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium cars based on your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Airport Transfers to Mumbai, Pune & Beyond",
    WhyChoosedescription: "Book a cab from Navi Mumbai International Airport to Mumbai, Navi Mumbai, Thane, Pune, Lonavala, Nashik, Surat, Ahmedabad, Goa, and other destinations across Maharashtra and India."
  },
  {
    WhyChooseheading: "Perfect for Business, Family & Tourist Travel",
    WhyChoosedescription: "Our airport cabs are suitable for corporate executives, families, tourists, hotel guests, students, medical travellers, and passengers looking for comfortable airport transportation."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs with Local Route Knowledge",
    WhyChoosedescription: "Our professional drivers understand Navi Mumbai routes, airport access roads, expressways, and city traffic patterns to provide safe and punctual travel."
  },
  {
    WhyChooseheading: "Clean, Sanitized & Comfortable Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, air-conditioned, sanitized, and inspected before each trip to provide passengers with a safe and pleasant airport transfer experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai International Airport Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking support, reliable chauffeur service, and comfortable airport transportation for every journey from Navi Mumbai International Airport."
  }
]

};

const faqData = [
  {
    question: "Can I pre-book a cab from Navi Mumbai International Airport?",
    answer: "Yes, you can reserve your airport cab in advance by sharing your flight details, pickup location, destination, and preferred vehicle."
  },
  {
    question: "Do you provide pickup and drop service at Navi Mumbai International Airport?",
    answer: "Yes, we provide convenient airport pickup and drop services for passengers arriving at or departing from Navi Mumbai International Airport."
  },
  {
    question: "Which vehicles are available for airport cab booking?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
  },
  {
    question: "Can I book a cab from Navi Mumbai International Airport to Pune?",
    answer: "Yes, direct airport transfers are available from Navi Mumbai International Airport to Pune and nearby areas."
  },
  {
    question: "Is the airport cab service available 24x7?",
    answer: "Yes, our Navi Mumbai International Airport cab service is available round the clock for scheduled flight arrivals and departures."
  },
  {
    question: "Do drivers track flight arrival timings?",
    answer: "Yes, flight details are considered during scheduling to help coordinate timely airport pickups."
  },
  {
    question: "Can I book a one-way airport taxi?",
    answer: "Yes, one-way airport transfers are available for local destinations as well as outstation cities."
  },
  {
    question: "How is the Navi Mumbai International Airport cab fare calculated?",
    answer: "The fare depends on the selected vehicle, destination, travel distance, trip timing, toll charges, parking fees, and additional requirements."
  },
  {
    question: "Do you provide airport cabs for corporate travel?",
    answer: "Yes, our airport transportation services are suitable for executives, business meetings, employee transfers, and corporate travel."
  },
  {
    question: "How can I book Navi Mumbai International Airport Cab with Shreesha Travels?",
    answer: "Share your flight details, travel date, pickup or drop location, passenger count, and vehicle preference to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Verma",
    feedback: "Excellent airport cab service from Navi Mumbai International Airport. The driver arrived on time, the vehicle was clean, and the entire journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Sharma",
    feedback: "Very reliable airport transfer service. The booking process was easy, the chauffeur was professional, and we reached our destination safely.",
    rating: 5
  }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai International Airport Cab",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-international-airport-cab.webp",
  "description":
    "Book Navi Mumbai International Airport Cab with Shreesha Tours & Travels for safe, reliable, and comfortable airport taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport pickup, airport drop, local transfers, corporate travel, family trips, and outstation journeys with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-international-airport-cab"
  }
};





    return (
        <div>


<Helmet>
  <title>Navi Mumbai International Airport Cab | Airport Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai International Airport Cab with Shreesha Travels for safe and comfortable airport taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for airport pickup, airport drop, local transfers, corporate travel, family trips, and 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Navi Mumbai International Airport Cab, Navi Mumbai International Airport Taxi, Navi Mumbai International Airport Cab Service, Taxi Service Navi Mumbai International Airport, Book Cab Navi Mumbai International Airport, Online Cab Booking Navi Mumbai International Airport, Navi Mumbai Airport Taxi Booking, Navi Mumbai Airport Pickup Cab, Navi Mumbai Airport Drop Taxi, Airport Transfer Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaiinternatinalairportcab;